import React from "react";
import LeaveWorkflowEditor from "./LeaveWorkflowEditor";

const LeaveGroupWorkflowSection = ({ darkMode, workflow, onChange }) => (
  <LeaveWorkflowEditor
    darkMode={darkMode}
    workflow={workflow}
    onChange={onChange}
    autoApprovedMessage="Leave requests for employees in this group will be auto-approved unless a leave type has its own approval settings."
  />
);

export default LeaveGroupWorkflowSection;
